import {dispatch} from '../dispatcher';
import common from './common';

const DietaryTagActions = {

  getDietaryTags: function() {
    common.promiseXHR('GET', 'v2/dietaryTags/all')
      .then(result => {
        dispatch({
          type: 'getDietaryTags/fetch',
          tags: result.data
        });
      });
  },

  getUserDietaryTags: function() {
    common.promiseXHR('GET', 'v2/dietaryTags/user')
      .then(result => {
        dispatch({
          type: 'getUserDietaryTags/fetch',
          user: result.data
        });
      });
  },
  updateUserDietaryTags: function(data) {
    return new Promise((resolve, reject) => {
      common.promiseXHR('PUT', 'v2/dietaryTags/user', data)
        .then(result => {
          dispatch({
            type: 'updateUserDietaryTags/set',
            newTags: JSON.stringify(data)
          });
        });
    });
  },


};

export default DietaryTagActions;